<template>
  <basic-container>
    <el-form
      :disabled="disabled"
      ref="form"
      :model="form"
      label-width="110px"
      label-="110px"
      margin-top="0"
      :rules="rules"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="房产" prop="roomId">
            <el-select
              :value="propertyName"
              ref="propertyAddParentNodeSelectRef"
              placeholder="请选择房产"
              clearable
              style="width: 100%;"
              :disabled="editDisable2"
            >
              <el-option :value="propertyName" show-all-levels :label="propertyName">
                <el-tree
                  ref="propertyAddParentNodeTreeRef"
                  node-key="id"
                  :props="treeProps"
                  :load="lazyLoadPropertyTree"
                  lazy
                  @node-click="propertyNodeTreeClick"
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="扣款银行" prop="bankId">
            <el-select
              v-model="bankName"
              @change="bankChange"
              placeholder="请选择扣款银行"
              style="width: 100%;"
              :disabled="editDisable2"
            >
              <el-option
                v-for="item in bankNameList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!--        <el-col :span="12">-->
        <!--          <el-form-item label="启用日期" prop="beginTime">-->
        <!--            <el-date-picker-->
        <!--              v-model="form.beginTime"-->
        <!--              type="date"-->
        <!--              placeholder="请选择启用日期"-->
        <!--              style="width: 100%;"-->
        <!--              :disabled="editDisable1"-->
        <!--              value-format="yyyy-MM-dd"-->
        <!--            ></el-date-picker>-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->
        <!--        <el-col :span="12">-->
        <!--          <el-form-item label="禁用日期" prop="unuseTime">-->
        <!--            <el-date-picker-->
        <!--              v-model="form.unuseTime"-->
        <!--              type="date"-->
        <!--              placeholder="请选择禁用日期"-->
        <!--              style="width: 100%;"-->
        <!--              :disabled="editDisable1"-->
        <!--              value-format="yyyy-MM-dd"-->
        <!--            ></el-date-picker>-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->
        <el-col :span="24">
          <el-form-item label="扣款账户" prop="accountNo">
            <el-input
              v-model="form.accountNo"
              :disabled="editDisable1"
              placeholder="请输入扣款账户"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="账户名称" prop="accountName">
            <el-input
              type="text"
              maxlength="30"
              v-model="form.accountName"
              :disabled="editDisable1"
              placeholder="请输入账户名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="账户备注" prop="accountRemark">
            <el-input
              type="textarea"
              :rows="4"
              v-model="form.accountRemark"
              :disabled="editDisable1"
              placeholder="请输入账户备注"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col></el-col>
      </el-row>
      <el-col offset="8">
        <el-form-item>
          <el-button type="primary" @click="onSubmit" style="width: 100px;" :hidden="editDisable1"
            >保存</el-button
          >
          <el-button type="danger" @click="closeDia" style="width: 100px;" :hidden="editDisable1"
            >退出</el-button
          >
        </el-form-item>
      </el-col>
    </el-form>
  </basic-container>
</template>
<script>
import { getLabelName, getPropertyTreeByObjectTypeKey } from '@/api/v4ward/itemset/feeitemset';
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getbank,
} from '@/api/v4ward/bankaccount/basebankaccount';
import { getDictionary } from '../../../api/common';
import SelectTree from '../../../components/vard-select-tree/vard-select-tree';
import { getTreeChildrenNode, getTreeChildrenPowerNode } from '@/api/v4ward/property/baseproperty';

export default {
  props: ['operateType', 'dataId', 'disabled'],
  components: {
    SelectTree,
  },
  data() {
    return {
      unitPriceName: '单位价格(元)',
      bankNameList: [],
      bankName: '',
      objectTypeList: [],
      propertyTreeList: [],
      props: {
        value: 'id',
        label: 'title',
        children: 'children',
        // disabled:true
      },
      ////
      propertyName: '',
      treeProps: {
        //标题
        label: 'title',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'isLeaf',
        //本节点类型key值
        objectType: 'objectType',
        //本节点类型名
        objectTypeName: 'objectTypeName',
      },
      ////
      optionValue: '',
      feeSortList: [],
      feeTypeList: [],
      feeCycleList: [],
      feeCycleNameDisable: true,
      disableEnableDicData: [
        { label: '启用', value: 1 },
        { label: '禁用', value: 0 },
      ],
      editDisable1: false, //针对不可编辑以外的属性
      editDisable2: false, //针对不可编辑属性： 如 费用种类，费项编码
      gradePriceDisable: true,
      unitPriceDisable: true,
      gradePriceShow: false, //阶梯价格显示
      switchValue: { yes: 1, no: 0 },
      bank: [],
      form: {
        roomId: '',
        bankId: '',
        beginTime: '',
        unuseTime: '',
        accountNo: '',
        accountName: '',
        accountRemark: '',
      },
      rules: {
        //objectTypeId: [{ required: true, message: '请选择费项范围', trigger: 'change' }],
        roomId: [{ required: true, message: '请选择房产', trigger: 'change' }],
        bankId: [{ required: true, message: '请选择银行', trigger: 'change' }],
        beginTime: [{ required: true, message: '请选择启用日期', trigger: 'change' }],
        unuseTime: [{ required: true, message: '请选择停用日期', trigger: 'change' }],
        accountNo: [
          {
            required: true,
            pattern: this.$validation.bankCard,
            message: '请输入正确的账户',
            trigger: 'change',
          },
        ],
        accountName: [{ required: true, message: '请输入账户名称', trigger: 'change' }],
      },
    };
  },
  created() {
    getbank().then((res) => {
      this.bankNameList = res.data;
    });
  },
  watch: {
    operateType() {
      this.initBankNameList();
      if (this.operateType === 'edit') {
        this.editDisable1 = false;
        this.editDisable2 = true;
      } else if (this.operateType === 'view') {
        this.editDisable1 = true;
        this.editDisable2 = true;
      }
    },
  },
  mounted() {
    this.initBankNameList();
    if (this.operateType === 'edit') {
      this.editDisable1 = false;
      this.editDisable2 = true;
    } else if (this.operateType === 'view') {
      this.editDisable1 = true;
      this.editDisable2 = true;
    }
  },
  methods: {
    bankChange(e) {
      this.form.bankId = e;
    },
    //获取银行名称
    initBankNameList: function () {
      if (this.bankNameList.length == 0) {
        getDictionary('bill_cutBank').then((data) => {
          this.bankNameList = data.data;
          if (['edit', 'view'].includes(this.operateType)) {
            getDetail({ id: this.dataId }).then(({ data }) => {
              this.form = data;
              for (var i = 0; i < this.bankNameList.length; i++) {
                if (this.bankNameList[i].dictKey == data.bankId) {
                  this.bankName = this.bankNameList[i].dictValue;
                }
              }
              this.propertyName = data.objectFullName;
            });
          }
        });
      } else {
        if (['edit', 'view'].includes(this.operateType)) {
          getDetail({ id: this.dataId }).then(({ data }) => {
            this.form = data;
            for (var i = 0; i < this.bankNameList.length; i++) {
              if (this.bankNameList[i].dictKey == data.bankId) {
                this.bankName = this.bankNameList[i].dictValue;
              }
            }
            this.propertyName = data.objectFullName;
          });
        }
      }
    },
    clearData: function () {
      this.form = {
        roomId: '',
        bankId: '',
        beginTime: '',
        unuseTime: '',
        accountNo: '',
        accountName: '',
        accountRemark: '',
      };
      this.unitPriceName = '单位价格(元)';
      this.feeCycleNameDisable = true;
      this.gradePriceDisable = true;
      this.unitPriceDisable = true;
    },
    ////////////
    lazyLoadPropertyTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
        //this.isPropertyAddDialogInit = true;
        //this.propertyAddParentNodeTreeRoot = node;
        //this.propertyAddParentNodeTreeResolve = resolve;
      } else {
        id = node.data.id;
      }

      getTreeChildrenPowerNode({ id: id, power: 2 }).then(({ data }) => {
        resolve(data);
      });
    },
    propertyNodeTreeClick(node) {
      let nodeId = node[this.treeProps.value];
      let nodeTitle = node[this.treeProps.label];
      let nodeTypeName = node[this.treeProps.objectTypeName];
      this.propertyName = nodeTitle;
      this.form.roomId = nodeId;

      if (this.propertyAddShowDialogFlag) {
        this.$refs.propertyAddParentNodeSelectRef.blur();
        //this.propertyAddForm.parentId = nodeId;
        //this.propertyAddForm.parentObjectTypeName = nodeTypeName;
      }
    },
    ///////////////
    onPropertySelected: function (value) {
      if (value == null) {
      } else {
        var node = this.getTreeNode(value, this.propertyTreeList);
        if (node == null || node.objectType !== this.form.objectTypeId) {
          this.form.roomId = '';
          this.$refs.selectTree.valueTitle = '';
          //this.$refs.selectTree.clearHandle();
        } else {
          this.form.roomId = value;
          this.$refs.selectTree.valueTitle = node.title;
        }
      }
    },
    getTreeNode: function (id, nodes) {
      var res;
      for (var i in nodes) {
        var node = nodes[i];
        if (node.id === id) {
          res = node;
        } else if (node.children) {
          var childFind = this.getTreeNode(id, node.children);
          if (typeof childFind !== 'undefined') {
            res = childFind;
          }
        }
      }
      return res;
    },
    casecadeUpdateProperty: function () {
      if (this.form.roomId) {
        this.onPropertySelected(this.form.roomId);
      }
    },
    closeRefreshDia: function () {
      this.editDisable1 = false;
      this.$emit('closeRefreshOtherform');
    },
    closeDia: function () {
      this.editDisable1 = false;
      this.$emit('closeOtherform');
    },
    // checkFormDataCorrect: function () {
    //   // 检查数据合法性
    //   var beginTime = Date.parse(this.form.beginTime);
    //   var unuseTime = Date.parse(this.form.unuseTime);
    //   var dateNow = new Date().getTime();
    //   console.log(0);
    //   if (!(beginTime < unuseTime)) {
    //     this.$message.error('禁用日期必须大于启用日期！');
    //     return false;
    //   }
    //   this.form.beginTime = this.appendSuffix(this.form.beginTime);
    //   this.form.unuseTime = this.appendSuffix(this.form.unuseTime);
    //   return true;
    // },
    appendSuffix(datetime) {
      if (datetime && datetime.length < 12) {
        return datetime + 'T00:00:00';
      } else {
        return datetime;
      }
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 检查数据合法性
          // var beginTime = Date.parse(this.form.beginTime);
          // var unuseTime = Date.parse(this.form.unuseTime);
          // console.log(0);
          // if (!(beginTime < unuseTime)) {
          //   this.$message.error('禁用日期必须大于启用日期！');
          //   return;
          // }
          add(this.form).then(() => {
            this.propertyName = '';
            this.form.roomId = '';
            this.form.bankId = '';
            this.form.beginTime = '';
            this.form.unuseTime = '';
            this.form.accountNo = '';
            this.form.accountName = '';
            this.form.accountRemark = '';
            this.$message.success('操作成功!');
            // this.onLoad();
            //this.clearData();
            this.closeRefreshDia();
            // this.$emit('closeAeform');
          });
        }
      });
      /* .then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        error => {
          done();
          console.log(error);
        }
      );*/
    },
  },
};
</script>
<style scoped>
.el-dialog__body {
  padding: 0 30px;
}
.el-dialog__body .el-card__body {
  padding: 0;
}
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 0;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
ul li >>> .el-tree .el-tree-node__content {
  height: auto;
  padding: 0 20px;
}
.el-tree-node__label {
  font-weight: normal;
}
.el-tree >>> .is-current .el-tree-node__label {
  color: #409eff;
  font-weight: 700;
}
.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}

.el-node-dialog-div {
  height: 400px;
  overflow: auto;
}

.el-property-dialog-div {
  height: 500px;
  overflow: auto;
}
</style>
